/**
 * 页面布局：索引与全屏路由（线框 wire / 实际 real）
 */
export const PAGE_LAYOUT_PAGES = [
  {
    slug: 'stack-kpi-detail',
    title: '1. 全局顶栏 · 模块导航 · 页内 Tab · KPI · 明细表',
    desc: '指标看板 + 下方大表：KPI 横排，其下同一白底卡内工具条 + 标准表。',
  },
  {
    slug: 'dual-table-midbar',
    title: '2. 上汇总表 + 中间工具条 + 下明细/树表',
    desc: '主区内上下双表，中间为筛选/导出横条。',
  },
  {
    slug: 'triple-viewport',
    title: '3. 左参数/步骤 + 中视口 + 右视口',
    desc: '双画布占位与左侧控制条；平台导航 + 二级导航。',
  },
  {
    slug: 'master-slave-panel',
    title: '4. 主从：左列表 + 右预览/详情',
    desc: '左侧标准表；右侧预览占位。',
  },
  {
    slug: 'nav-layers-tree-table',
    title: '5. 多层导航条 + 左树 + 右主表',
    desc: '三/四级条 + 左树右表。',
  },
  {
    slug: 'sidebar-kpi-main-table',
    title: '6. 左侧边栏 + 右侧 Tab · KPI · 主表',
    desc: '侧栏树与小表；右侧 KPI + 主表。',
  },
  {
    slug: 'tabs-single-table-board',
    title: '7. 顶栏 · 模块条 · 页签条 · 单表主区',
    desc: '白底卡内单张大表。',
  },
  {
    slug: 'tree-panel-right-table',
    title: '8. 左树表 + 右分段/Tab/工具条/主表',
    desc: '左侧树表；右侧分段、Tab、工具条与主表。',
  },
  {
    slug: 'settings-dual-cards',
    title: '9. 左竖向设置菜单 + 右双面板',
    desc: '无二级导航条；双列卡片各含标准表。',
  },
  {
    slug: 'list-drawer-push',
    title: '10. 灰底条带列表 + 右推入详情（非遮罩抽屉）',
    desc: 'Greyscale/100 列表区 + 白色行卡片；点击行右侧推入详情面板（参考 DT26 / MCP 7099:197947）。与 master-slave 固定分栏不同。',
  },
  {
    slug: 'split-aside-main-table',
    title: '11. 左分类导航卡 + 右主区（Tab · 说明 · 工具栏 · 树表）',
    desc: 'Canvas 内双白卡 + 16px 槽；左栏约 200px 扁平分类导航；右栏 Tab 行 48px + 黄条按文案宽 + 文字按钮贴右；工具栏左操作/右预览；递进色树表缩进 20。参考 DT42。',
  },
];

PAGE_LAYOUT_PAGES.forEach((p) => {
  p.pathWire = `/business/page-layouts/p/${p.slug}/wire`;
  p.pathReal = `/business/page-layouts/p/${p.slug}/real`;
});
